import store from '@/store/index'
import axios from 'axios'
import cfg from '../config'
import router from '../router'

const auth = cfg.reqAuth // 暂时 todo

export const getToken = async () => {
  return await store.dispatch('user/getToken')
}

export const getRefreshToken = async () => {
  return await store.dispatch('user/getRefreshToken')
}

export const loginOut = () => {
  return store.dispatch('user/loginOut')
}

export const checkRefreshToken = (refreshToken, tempStatusLoading) => {
  if (tempStatusLoading.state) {
    return
  }
  tempStatusLoading.state = true
  return axios.post(
    `${cfg.baseApi}/user/api/v1/oauth/token`,
    `grant_type=refresh_token&refresh_token=${refreshToken}&circle=1`, {
      headers: {
        Authorization: auth,
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        ver: 'v1.00'
      }
    }
  ).then(response => {
    const res = response.data
    tempStatusLoading.state = false
    if (res && parseInt(res.status) === 0 && res.data && res.data.access_token) {
      const accessToken = res.data.access_token
      const refreshToken = res.data.refresh_token

      localStorage.setItem('token_key', accessToken)
      localStorage.setItem('token_buffer', refreshToken)

      window.location.reload(true)
    } else {
      loginOut().then(res => {
        router.push({
          path: '/login'
        })
      })
    }
  }).catch(e => {
    tempStatusLoading.state = false
  })
}
